exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tableNumberDropdown-formControl {\n  width: 100%; }\n\n.tableNumberDropdown-select {\n  width: 100%;\n  font-family: 'Lato-Regular', sans-serif;\n  color: var(--text); }\n\n.tableNumberDropdown-titleAndDropdownContainer {\n  display: flex;\n  margin: 8px 0 0 0; }\n\n.tableNumberDropdown-labelContainer {\n  flex: 1;\n  display: flex;\n  align-items: center; }\n\n.tableNumberDropdown-dropdownContainer {\n  width: auto; }\n\n.tableNumberDropdown-labelTitleText {\n  font-size: 14px;\n  font-family: 'Lato-Regular', sans-serif;\n  color: var(--text); }\n\n.tableNumberDropdown-menuListRoot {\n  padding-right: 1vw; }\n", ""]);

// exports
